import { supabase } from '../helper/supabaseClient';

/**
 * @returns {{ country: string|null, community_id: string|null }}
 */
export async function fetchProfileCommunityFields(userId) {
  const { data, error } = await supabase
    .from('Profiles')
    .select('country, community_id')
    .eq('id', userId)
    .maybeSingle();

  if (error) throw new Error(error.message || 'Failed to load profile');

  return {
    country: data?.country ?? null,
    community_id: data?.community_id ?? null,
  };
}

/**
 * Updates country and community on `public."Profiles"`.
 */
export async function updateProfileCountryCommunity(userId, { country, community_id }) {
  const { data, error } = await supabase
    .from('Profiles')
    .update({
      country: country ?? null,
      community_id: community_id ?? null,
    })
    .eq('id', userId)
    .select('country, community_id')
    .single();

  if (error) throw new Error(error.message || 'Failed to save profile');

  return {
    country: data?.country ?? null,
    community_id: data?.community_id ?? null,
  };
}
